import { Outlet, createFileRoute, useParams } from '@tanstack/react-router';

import { HStack } from '@/components/Layout';

import { TestReviewSidebar } from './-components/TestReviewSidebar';

export const Route = createFileRoute(
  '/_stacktrace/test-suites/$id/_layout/test-review/_layout',
)({
  component: TestReviewLayout,
});

function TestReviewLayout() {
  const { id } = useParams({ from: '/_stacktrace/test-suites/$id/_layout' });

  return (
    <HStack className="items-start gap-6 px-12 py-5 grow min-w-0">
      <TestReviewSidebar id={id} />
      <div className="grow min-w-0">
        <Outlet />
      </div>
    </HStack>
  );
}
